export const state = () => ({
    isSpinnerModalOpened: false
});

export const getters = {
    isSpinnerModalOpened: state => state.isSpinnerModalOpened
};

export const mutations = {
    SET_IS_SPINNER_MODAL_OPENED(state, value) {
        state.isSpinnerModalOpened = value;
    }
};

export const actions = {
    setIsSpinnerModalOpened({ commit }, value) {
        commit('SET_IS_SPINNER_MODAL_OPENED', value);
    }
};
